import React, {useEffect, useRef, useState} from 'react';
import classes from "../../components/audio/audio.module.css";

const CustomAudioPlayer = ({ src }) => {
        const audioRef = useRef(null);
        const progressRef = useRef(null);
        const [playing, setPlaying] = useState(false);
        const [duration, setDuration] = useState(0);
        const [currentTime, setCurrentTime] = useState(0);

        const togglePlay = () => {
            const audio = audioRef.current;
            if (!audio) return;

            if (playing) {
                audio.pause();
            } else {
                audio.play().catch((e) => console.error('Ошибка воспроизведения:', e));
            }
            setPlaying(!playing);
        };

        const formatTime = (time) => {
            const minutes = Math.floor(time / 60) || 0;
            const seconds = Math.floor(time % 60) || 0;
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        };


        const handleSeek = (e) => {
            const audio = audioRef.current;
            const progress = progressRef.current;
            if (!audio || !progress) return;

            const rect = progress.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            audio.currentTime = (clickX / rect.width) * duration;
        };

        useEffect(() => {
            const audio = audioRef.current;
            if (!audio) return;

            const onTimeUpdate = () => setCurrentTime(audio.currentTime);
            const onLoadedMetadata = () => setDuration(audio.duration);
            const onEnded = () => {
                setPlaying(false);
                setCurrentTime(0);
            };

            audio.addEventListener('timeupdate', onTimeUpdate);
            audio.addEventListener('loadedmetadata', onLoadedMetadata);
            audio.addEventListener('ended', onEnded);

            return () => {
                audio.removeEventListener('timeupdate', onTimeUpdate);
                audio.removeEventListener('loadedmetadata', onLoadedMetadata);
                audio.removeEventListener('ended', onEnded);
            };
        }, []);

        const progressPercent = duration ? (currentTime / duration) * 100 : 0;

        return (
            <div className={`${classes.custom_audio_player}`}>
                <audio ref={audioRef} src={src} preload="none" />
                <button className={classes.play_button} onClick={togglePlay}>
                    {playing ? '❚❚' : '►'}
                </button>

                <div className={classes.time}>
                    {formatTime(currentTime)} / {formatTime(duration)}
                </div>

                <div
                    className={classes.progress_container}
                    onClick={handleSeek}
                    ref={progressRef}
                >
                    <div
                        className={classes.progress_bar}
                        style={{ width: `${progressPercent}%` }}
                    />
                </div>

            </div>
        );
    };

    export default CustomAudioPlayer;
